<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <nav
        class="breadcrumb-container d-flex align-items-center justify-content-between mb-3 mt-md-0 mt-4"
      >
        <div class="d-flex align-items-center">
          <a
            class="back-link d-flex align-items-center justify-content-center me-3"
            routerLink="/applicationlist"
            [title]="'COMMON.BACK' | translate"
          >
            <mat-icon>arrow_back</mat-icon>
          </a>

          <div class="d-flex align-items-center me-2">
            <div
              class="avatar-wrapper position-relative border rounded flex-shrink-0"
              style="width: 36px; height: 36px; overflow: visible"
            >
              <div
                style="width: 100%; height: 100%; overflow: hidden"
                class="rounded"
              >
                <img
                  [src]="getDocThumbnail(applicationForm.data['logo'])"
                  class="w-100 h-100"
                  style="object-fit: contain"
                />
              </div>
              <span class="status-indicator"></span>
            </div>
            <div class="ms-3">
              <h6 class="mb-0 text-dark text-wrap text-break lh-1">
                {{ applicationForm.data["name"] }}
              </h6>
            </div>
          </div>

          <i class="bx bx-chevron-right text-muted mx-2 opacity-50"></i>

          <div class="d-flex align-items-center">
            <div class="me-2 d-flex align-items-center justify-content-center">
              <i class="bx bx-network-chart text-primary"></i>
            </div>
            <span class="fw-semibold uppercase-tracking">
              {{ "APPLICATIONS.API" | translate }}
            </span>
          </div>
        </div>
      </nav>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 col-xl-4 px-1">
      <div class="card shadow-sm border-0">
        <div class="card-header">
          <h6 class="mb-3">{{ "APIS.TITLE" | translate }}</h6>
          <div class="row compact-inputs dropdown-pd-none">
            <div class="col-xl-6 col-auto mb-2 pe-1">
              <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                class="w-100 mb-1"
              >
                <mat-label>{{ "COMMON.SEARCH" | translate }}</mat-label>
                <input
                  matInput
                  [(ngModel)]="searchUsecaseItem"
                  type="text"
                  id="searchUsecaseInput"
                  name="searchUsecase"
                />
              </mat-form-field>
            </div>
            <div class="col-xl-3 col-auto mb-2 ps-1">
              <button
                mat-stroked-button
                color="primary"
                class="app-btn-mdc"
                [matTooltip]="'APIS.ADD_NEW_API' | translate"
                (click)="getUsecase(0)"
              >
                <mat-icon>add</mat-icon>
                {{ "COMMON.ADD" | translate }}
              </button>
            </div>
            <div class="col-xl-3 col-auto mb-2 ps-1">
              <div>
                <ul class="nav nav-pills" id="pills-tab" role="tablist">
                  <li
                    class="nav-item"
                    role="presentation"
                    *ngIf="!isProfileTabActive"
                  >
                    <button
                      mat-stroked-button
                      color="primary"
                      class="icon-width icon-center"
                      id="pills-home-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-home"
                      type="button"
                      role="tab"
                      aria-controls="pills-home"
                      aria-selected="true"
                      (click)="toggleTab('profile')"
                    >
                      <mat-icon>unarchive</mat-icon>
                    </button>
                  </li>
                  <li
                    class="nav-item"
                    role="presentation"
                    *ngIf="isProfileTabActive"
                  >
                    <button
                      mat-stroked-button
                      color="primary"
                      class="icon-width icon-center"
                      id="pills-profile-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-profile"
                      role="tab"
                      aria-controls="pills-profile"
                      type="button"
                      (click)="toggleTab('home')"
                    >
                      <mat-icon>format_list_bulleted</mat-icon>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body half-screen p-1 compact-inputs">
          <div class="row">
            <div class="col-12">
              <div class="tab-content" id="pills-tabContent">
                <div
                  class="tab-pane fade"
                  [class.show]="!isProfileTabActive"
                  [class.active]="!isProfileTabActive"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <div
                    class="d-flex flex-column mt-2 mytext-primary darkmode-div"
                  >
                    <div
                      *ngFor="let e of filterUsecases(); let i = index"
                      class="card border-0 shadow-sm border-start border-4 transition-all"
                      [ngClass]="
                        selectedUsecaseId === e['id']
                          ? 'border-primary bg-light'
                          : 'border-light bg-white'
                      "
                    >
                      <div
                        class="p-2 d-flex flex-xl-column flex-md-row flex-column justify-content-between flex-wrap gap-2"
                      >
                        <div
                          class="d-flex align-items-center flex-grow-1 overflow-hidden mb-2"
                        >
                          <span
                            class="badge rounded-pill bg-secondary bg-opacity-10 text-dark me-2 px-2 py-1"
                            style="font-size: 0.75rem"
                          >
                            {{ i + 1 }}
                          </span>
                          <a
                            href="javascript:void(0)"
                            class="text-decoration-none fw-bold text-dark text-truncate d-block"
                            [title]="e['name']"
                          >
                            {{ e["name"] | truncate: 25 }}
                          </a>
                        </div>
                        <div class="d-flex align-items-center gap-1">
                          <div class="d-flex gap-2">
                            <button
                              mat-button
                              class="btn btn-sm sm-btn"
                              [ngClass]="
                                selectedUsecaseId === e['id']
                                  ? 'bg-primary bg-opacity-10 primary-text border border-primary border-opacity-25'
                                  : 'bg-light primary-text'
                              "
                              (click)="getUsecase(e['id'])"
                              [matTooltip]="'COMMON.EDIT' | translate"
                            >
                              <div
                                class="d-flex align-items-center justify-content-center"
                              >
                                <i class="bx bx-edit"></i>
                                <small class="ms-1">{{
                                  "COMMON.EDIT" | translate
                                }}</small>
                              </div>
                            </button>

                            <button
                              mat-button
                              class="btn btn-sm sm-btn bg-light primary-text"
                              [routerLink]="['/customapis/' + e.id]"
                              [matTooltip]="'APPLICATIONS.API' | translate"
                            >
                              <div
                                class="d-flex align-items-center justify-content-center"
                              >
                                <i class="bx bx-network-chart"></i>
                                <small class="ms-1">{{
                                  "APPLICATIONS.API" | translate
                                }}</small>
                              </div>
                            </button>

                            <button
                              mat-button
                              class="btn btn-sm sm-btn bg-light primary-text"
                              [routerLink]="['/uiformcreate/' + e.id]"
                              [matTooltip]="'APPLICATIONS.UI_FORMS' | translate"
                            >
                              <div
                                class="d-flex align-items-center justify-content-center"
                              >
                                <i class="bx bx-credit-card-front"></i>
                                <small class="ms-1">{{
                                  "APPLICATIONS.UI_FORMS" | translate
                                }}</small>
                              </div>
                            </button>

                            <button
                              mat-button
                              class="btn btn-sm sm-btn bg-light primary-text"
                              [routerLink]="'/usecasedata/' + e.id"
                              [matTooltip]="
                                'APPLICATIONS.DATA_TITLE' | translate
                              "
                            >
                              <div
                                class="d-flex align-items-center justify-content-center"
                              >
                                <i class="bx bx-data"></i>
                                <small class="ms-1">{{
                                  "APPLICATIONS.DATA" | translate
                                }}</small>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  [class.show]="isProfileTabActive"
                  [class.active]="isProfileTabActive"
                  id="pills-profile"
                  role="tabpanel"
                  aria-labelledby="pills-profile-tab"
                >
                  <div
                    class="d-flex flex-column card border-0 bg-light bg-opacity-50"
                  >
                    <div
                      *ngFor="let e of form.archivedlist; let i = index"
                      class=""
                    >
                      <div
                        class="card-body p-2 px-2 d-flex align-items-center justify-content-between"
                      >
                        <div class="d-flex align-items-center">
                          <small class="text-muted me-1">{{ i + 1 }}.</small>
                          <span class="text-muted small fw-medium">
                            {{ e["name"] | truncate }}
                          </span>
                        </div>
                        <button
                          mat-stroked-button
                          disabled
                          [matTooltip]="'APPLICATIONS.RETRIEVE' | translate"
                        >
                          <mat-icon class="me-1">unarchive</mat-icon>
                          <span>
                            {{ "APPLICATIONS.RETRIEVE" | translate }}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xl-8 px-1">
      <div class="card shadow-sm border-0 compact-inputs">
        <div class="card-body half-screen2 compact-inputs dropdown-pd-none">
          <!-- Error/Success messages -->
          <p *ngIf="form['error'] == false && form['message']">
            <app-ncs-alert [message]="form['message']" type="success" />
          </p>
          <p *ngIf="form['error'] == true && form['message']">
            <app-ncs-alert [message]="form['message']" type="danger" />
          </p>

          <div class="row">
            <div class="col-md-12">
              <div
                class="d-flex align-items-center justify-content-between flex-wrap mb-2"
              >
                <h5 class="text-wrap text-break me-2">
                  {{ form.data["name"] }}
                </h5>
                <div class="d-flex gap-2 ms-auto">
                  <button
                    mat-stroked-button
                    color="primary"
                    type="button"
                    [matTooltip]="'COMMON.SAVE' | translate"
                    [disabled]="!appForm.valid"
                    (click)="save()"
                  >
                    <mat-icon class="icon-compact">save</mat-icon>
                    <small>{{ "COMMON.SAVE" | translate }}</small>
                  </button>
                  <button
                    mat-stroked-button
                    color="primary"
                    type="submit"
                    [matTooltip]="'APPLICATIONS.ARCHIVE' | translate"
                    *ngIf="form.data['id'] && form.data['id'] > 0"
                    (click)="delete(form.data['id'])"
                  >
                    <mat-icon class="icon-compact">archive</mat-icon>
                    <small>{{ "APPLICATIONS.ARCHIVE" | translate }}</small>
                  </button>
                </div>
              </div>
            </div>

            <div class="col-md-12 col-lg-4 mb-2">
              <form class="" #appForm="ngForm">
                <div class="mb-2">
                  <label class="mb-1">{{ "COMMON.NAME" | translate }}</label>
                  <mat-form-field appearance="outline" class="w-100 mb-2">
                    <input
                      matInput
                      type="text"
                      id="name"
                      name="name"
                      required
                      maxlength="50"
                      [(ngModel)]="form.data['name']"
                      (input)="checkUsecaseName($event)"
                      [placeholder]="'COMMON.NAME' | translate"
                    />
                    <span style="color: #ff0000"
                      >{{ form.inputerror?.collectionName }}
                    </span>
                  </mat-form-field>
                </div>

                <div class="mb-2">
                  <label class="mb-1">{{ "COMMON.CODE" | translate }}</label>
                  <mat-form-field appearance="outline" class="w-100 mb-2">
                    <input
                      matInput
                      [disabled]="true"
                      [(ngModel)]="form.data['code']"
                      type="text"
                      id="code"
                      name="code"
                      [placeholder]="'COMMON.CODE' | translate | lowercase"
                    />
                  </mat-form-field>
                </div>
                <div class="textarea-container">
                  <label class="mb-2">{{
                    "COMMON.DESCRIPTION" | translate
                  }}</label>
                  <mat-form-field appearance="outline" class="w-100">
                    <textarea
                      matInput
                      rows="5"
                      [(ngModel)]="form.data['description']"
                      id="description"
                      name="description"
                      [placeholder]="'COMMON.DESCRIPTION' | translate"
                    >
                    </textarea>
                  </mat-form-field>
                </div>
              </form>
            </div>

            <div
              class="col-md-12 col-lg-3 mb-2 p-lg-1"
              [ngStyle]="
                form.data['id'] === undefined || form.data['id'] === 0
                  ? {
                      'user-select': 'none',
                      'pointer-events': 'none',
                      opacity: '0.5',
                    }
                  : {}
              "
            >
              <h6>{{ "APIS.PAGE_FEATURES" | translate }}</h6>
              <div>
                <div
                  class="mb-1 d-flex align-items-center justify-content-between"
                >
                  <mat-slide-toggle
                    id="comment"
                    name="comment"
                    color="primary"
                    [(ngModel)]="form.data['commentEnabled']"
                    (change)="
                      toggleVal(
                        form.data['commentEnabled'],
                        form.data,
                        'commentEnabled'
                      )
                    "
                  >
                    <span class="smallfs">
                      {{ "APIS.FEATURES.PAGE_COMMENT" | translate }}
                    </span>
                  </mat-slide-toggle>
                  <i
                    class="bi bi-info-circle"
                    [matTooltip]="'APIS.TOOLTIPS.PAGE_COMMENT' | translate"
                    matTooltipPosition="above"
                  ></i>
                </div>
                <div
                  class="mb-1 d-flex align-items-center justify-content-between"
                >
                  <mat-slide-toggle
                    id="email"
                    name="email"
                    color="primary"
                    [(ngModel)]="form.data['emailEnabled']"
                    (change)="
                      toggleVal(
                        form.data['emailEnabled'],
                        form.data,
                        'emailEnabled'
                      )
                    "
                  >
                    <span class="smallfs">
                      {{ "APIS.FEATURES.PAGE_EMAIL" | translate }}
                    </span>
                  </mat-slide-toggle>
                  <i
                    class="bi bi-info-circle"
                    [matTooltip]="'APIS.TOOLTIPS.PAGE_EMAIL' | translate"
                    matTooltipPosition="above"
                  ></i>
                </div>
                <div
                  class="mb-1 d-flex align-items-center justify-content-between"
                >
                  <mat-slide-toggle
                    id="attachment"
                    name="attachment"
                    color="primary"
                    [(ngModel)]="form.data['attachmentEnabled']"
                    (change)="
                      toggleVal(
                        form.data['attachmentEnabled'],
                        form.data,
                        'attachmentEnabled'
                      )
                    "
                  >
                    <span class="smallfs">
                      {{ "APIS.FEATURES.PAGE_ATTACHMENT" | translate }}
                    </span>
                  </mat-slide-toggle>
                  <i
                    class="bi bi-info-circle"
                    [matTooltip]="'APIS.TOOLTIPS.PAGE_ATTACHMENT' | translate"
                    matTooltipPosition="above"
                  ></i>
                </div>

                <hr />
                <h6>{{ "APIS.DATA_MANAGEMENT" | translate }}</h6>
                <div
                  class="mb-1 d-flex align-items-center justify-content-between"
                >
                  <mat-slide-toggle
                    id="version"
                    name="version"
                    color="primary"
                    [(ngModel)]="form.data['versionHistory']"
                    (change)="
                      toggleVal(
                        form.data['versionHistory'],
                        form.data,
                        'versionHistory'
                      )
                    "
                  >
                    <span class="smallfs">
                      {{ "APIS.FEATURES.DATA_VERSIONING" | translate }}
                    </span>
                  </mat-slide-toggle>

                  <i
                    class="bi bi-info-circle"
                    [matTooltip]="'APIS.TOOLTIPS.DATA_VERSIONING' | translate"
                    matTooltipPosition="above"
                  ></i>
                </div>
                <div
                  class="mb-1 d-flex align-items-center justify-content-between"
                >
                  <mat-slide-toggle
                    id="archived"
                    name="archived"
                    color="primary"
                    [(ngModel)]="form.data['archiveEnabled']"
                    (change)="
                      toggleVal(
                        form.data['archiveEnabled'],
                        form.data,
                        'archiveEnabled'
                      )
                    "
                  >
                    <span class="smallfs">
                      {{ "APIS.FEATURES.DATA_ARCHIVE" | translate }}
                    </span>
                  </mat-slide-toggle>
                  <i
                    class="bi bi-info-circle"
                    [matTooltip]="'APIS.TOOLTIPS.DATA_ARCHIVE' | translate"
                    matTooltipPosition="above"
                  ></i>
                </div>
                <div
                  class="mb-1 d-flex align-items-center justify-content-between"
                >
                  <mat-slide-toggle
                    id="changeLog"
                    name="changeLog"
                    color="primary"
                    [(ngModel)]="form.data['changeLog']"
                    (change)="
                      toggleVal(form.data['changeLog'], form.data, 'changeLog')
                    "
                  >
                    <span class="smallfs">
                      {{ "APIS.FEATURES.DATA_CHANGE_LOG" | translate }}
                    </span>
                  </mat-slide-toggle>
                  <i
                    class="bi bi-info-circle"
                    [matTooltip]="'APIS.TOOLTIPS.DATA_CHANGE_LOG' | translate"
                    matTooltipPosition="above"
                  ></i>
                </div>
                <div
                  class="mb-1 d-flex align-items-center justify-content-between"
                >
                  <mat-slide-toggle
                    id="tagenable"
                    name="tagenable"
                    color="primary"
                    [(ngModel)]="form.data['tagenable']"
                    (change)="
                      toggleVal(form.data['tagenable'], form.data, 'tagenable')
                    "
                  >
                    <span class="smallfs">
                      {{ "APIS.FEATURES.ENABLE_TAG" | translate }}
                    </span>
                  </mat-slide-toggle>
                  <i
                    class="bi bi-info-circle"
                    [matTooltip]="'APIS.TOOLTIPS.ENABLE_TAG' | translate"
                    matTooltipPosition="above"
                  ></i>
                </div>

                <hr />
                <h6>{{ "APIS.EXPORT_FILTERING" | translate }}</h6>
                <div
                  class="mb-1 d-flex align-items-center justify-content-between"
                >
                  <mat-slide-toggle
                    id="userFilter"
                    name="userFilter"
                    color="primary"
                    [(ngModel)]="form.data['userFilter']"
                    (change)="
                      toggleVal(
                        form.data['userFilter'],
                        form.data,
                        'userFilter'
                      )
                    "
                  >
                    <span class="smallfs">
                      {{ "APIS.FEATURES.USER_FILTER" | translate }}
                    </span>
                  </mat-slide-toggle>
                  <i
                    class="bi bi-info-circle"
                    [matTooltip]="'APIS.TOOLTIPS.USER_FILTER' | translate"
                    matTooltipPosition="above"
                  ></i>
                </div>
                <div
                  class="mb-1 d-flex align-items-center justify-content-between"
                >
                  <mat-slide-toggle
                    id="groupFilter"
                    name="groupFilter"
                    color="primary"
                    [(ngModel)]="form.data['groupFilter']"
                    (change)="
                      toggleVal(
                        form.data['groupFilter'],
                        form.data,
                        'groupFilter'
                      )
                    "
                  >
                    <span class="smallfs">
                      {{ "APIS.FEATURES.GROUP_FILTER" | translate }}
                    </span>
                  </mat-slide-toggle>
                  <i
                    class="bi bi-info-circle"
                    [matTooltip]="'APIS.TOOLTIPS.GROUP_FILTER' | translate"
                    matTooltipPosition="above"
                  ></i>
                </div>
                <div
                  class="mb-1 d-flex align-items-center justify-content-between"
                >
                  <mat-slide-toggle
                    id="export"
                    name="export"
                    color="primary"
                    [(ngModel)]="form.data['exportEnabled']"
                    (change)="
                      toggleVal(
                        form.data['exportEnabled'],
                        form.data,
                        'exportEnabled'
                      )
                    "
                  >
                    <span class="smallfs">
                      {{ "APIS.FEATURES.EXCEL_EXPORT" | translate }}
                    </span>
                  </mat-slide-toggle>
                  <i
                    class="bi bi-info-circle"
                    [matTooltip]="'APIS.TOOLTIPS.EXCEL_EXPORT' | translate"
                    matTooltipPosition="above"
                  ></i>
                </div>
              </div>
            </div>

            <div
              class="col-md-12 col-lg-5 mb-2"
              [ngStyle]="
                form.data['id'] === undefined || form.data['id'] === 0
                  ? {
                      'user-select': 'none',
                      'pointer-events': 'none',
                      opacity: '0.5',
                    }
                  : {}
              "
            >
              <form class="p-1">
                <div class="mb-2">
                  <label class="form-label form-label-sm">
                    {{ "APIS.LIST_LABEL" | translate }}:
                  </label>
                  <div class="d-flex align-items-start gap-1">
                    <mat-form-field
                      appearance="outline"
                      class="w-100 compact-inputs"
                    >
                      <mat-label>{{ "COMMON.SELECT" | translate }}</mat-label>
                      <mat-select
                        [(value)]="selectedListLabelCode"
                        [placeholder]="'COMMON.SELECT' | translate"
                      >
                        <mat-option
                          *ngFor="let e of labelListAttributes()"
                          [value]="e['code']"
                          (click)="selectListLabel(e)"
                        >
                          <small [title]="e['label']">
                            {{ e["label"] | truncate: 20 }}
                          </small>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <button
                      class="mat-attached-btn"
                      (click)="
                        $event.stopPropagation();
                        updateList('dropdown', selectedListLabelCode, false)
                      "
                    >
                      <!-- <mat-icon>add</mat-icon> -->
                      <small><i class="fa fa-plus"></i></small>
                      <small>{{ "COMMON.ADD" | translate }}</small>
                    </button>
                  </div>
                  <div class="my-2">
                    <button
                      *ngFor="let e of form.data['dropdown']"
                      (click)="updateList('dropdown', e, true)"
                      type="button"
                      class="btn btn-outline-secondary btn-sm me-1 p-1 mb-1 truncate-btn"
                      [title]="e"
                    >
                      <span class="text-truncate">{{ e }}</span>
                      <i class="fa fa-times ms-1 fs-6"></i>
                    </button>
                  </div>
                </div>

                <div class="mb-2">
                  <label class="form-label form-label-sm">
                    {{ "APIS.EXPORT_COLUMNS" | translate }}:
                  </label>
                  <div class="d-flex align-items-start gap-1">
                    <mat-form-field
                      appearance="outline"
                      class="w-100 compact-inputs mb-2"
                    >
                      <mat-label>{{ "COMMON.SELECT" | translate }}</mat-label>
                      <mat-select
                        [(value)]="selectedExcelAttrCode"
                        [placeholder]="'COMMON.SELECT' | translate"
                      >
                        <mat-select-trigger>
                          {{
                            selectedExcelAttrLabel ||
                              ("COMMON.SELECT" | translate)
                          }}
                        </mat-select-trigger>
                        <mat-option
                          *ngFor="let e of allowedTypes()"
                          [value]="e['code']"
                          (click)="selectExcelAttr(e)"
                        >
                          <small [title]="e['label']">
                            {{ e["label"] | truncate: 20 }}
                          </small>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <button
                      class="mat-attached-btn"
                      (click)="
                        $event.stopPropagation();
                        updateList(
                          'excelAttributes',
                          selectedExcelAttrCode,
                          false
                        )
                      "
                    >
                      <!-- <mat-icon>add</mat-icon> -->
                      <small><i class="fa fa-plus"></i></small>
                      <small>{{ "COMMON.ADD" | translate }}</small>
                    </button>
                  </div>
                  <div class="mb-2">
                    <button
                      *ngFor="let e of form.data['excelAttributes']"
                      (click)="updateList('excelAttributes', e, true)"
                      type="button"
                      class="btn btn-outline-secondary btn-sm me-1 p-1 mb-1 truncate-btn"
                      [title]="e"
                    >
                      <span class="text-truncate">{{ e }}</span>
                      <i class="fa fa-times ms-1 fs-6"></i>
                    </button>
                  </div>
                </div>

                <div class="mb-2">
                  <div class="mb-3">
                    <label class="mat-label-custom mb-2">
                      {{ "APIS.COMPOSITE_KEYS" | translate }}:
                    </label>
                    <div class="d-flex align-items-start gap-1 mb-2">
                      <mat-form-field
                        appearance="outline"
                        class="compact-inputs"
                        class="w-100"
                      >
                        <mat-label>
                          {{ "COMMON.SELECT" | translate }}
                          {{ "APIS.COMPOSITE_KEYS" | translate | lowercase }}
                        </mat-label>
                        <mat-select multiple [(value)]="selectedItems">
                          <mat-option
                            *ngFor="let e of filterAttributesComposite()"
                            [value]="e['code']"
                            [title]="e['label'].replace('Id', '')"
                            (onSelectionChange)="onCheckboxChange($event)"
                          >
                            <small>{{ e["label"].replace("Id", "") }}</small>
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <button
                        class="mat-attached-btn"
                        [disabled]="selectedItems.length <= 1"
                        matSuffix
                        (click)="addSelectedItems(); $event.stopPropagation()"
                        type="button"
                        [title]="'COMMON.ADD' | translate"
                      >
                        <small><i class="fa fa-plus"></i></small>
                        <small>{{ "COMMON.ADD" | translate }}</small>
                      </button>
                    </div>
                    <div class="mb-2">
                      <ng-container *ngFor="let e of form.data['unique']">
                        <ng-container *ngIf="isArray(e)">
                          <button
                            (click)="deleteComposeList('compKey', e, true)"
                            type="button"
                            class="btn btn-outline-secondary btn-sm me-1 mb-1 truncate-btn"
                            [attr.title]="e"
                          >
                            <span class="truncate-text">{{ e }}</span>
                            <i class="fa fa-times ms-2 fs-6"></i>
                          </button>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <hr class="mt-2" />
                <div class="mb-2">
                  <label for="dropdown" class="form-label form-label-sm">
                    {{ "APIS.PARENT_USECASE" | translate }}:
                  </label>
                  <div class="d-flex align-items-start gap-1 mb-2">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>
                        {{ "COMMON.SELECT" | translate }}
                      </mat-label>
                      <mat-select [(value)]="selectedParentId">
                        <mat-option
                          *ngFor="let e of filterParentList()"
                          [value]="e['id']"
                          [title]="e['name'] + ' (' + e['code'] + ')'"
                          (onSelectionChange)="
                            selectedParentId === e['id']
                              ? onSelectParent(e)
                              : null
                          "
                        >
                          <small class="text-truncate">
                            {{ e["name"] | truncate: 20 }} ({{
                              e["code"] | truncate: 20
                            }})
                          </small>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <button
                      class="mat-attached-btn"
                      (click)="
                        addParentUscase(selectedParentId);
                        $event.stopPropagation()
                      "
                      type="button"
                    >
                      <i class="fa fa-save" style="font-size: 0.85rem"></i>
                      <small>{{ "COMMON.SAVE" | translate }}</small>
                    </button>
                  </div>
                  <!-- Truncated buttons with full title -->
                  <div class="mb-2">
                    <button
                      *ngFor="let e of parentUsecases | keyvalue"
                      (click)="removeParentUscase(e.key)"
                      type="button"
                      class="btn btn-outline-secondary btn-sm me-1 mb-1 truncate-btn"
                      [title]="e.value.parentName"
                    >
                      <span class="truncate-text">{{
                        e.value.parentName
                      }}</span>
                      <i class="fa fa-times ms-2 fs-6"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 px-1">
      <div class="card shadow-sm border-0">
        <div class="card-header">
          <h5 class="m-0">{{ "ATTRIBUTES.TITLE" | translate }}</h5>
        </div>
        <div class="card-body">
          <div class="row align-items-center compact-inputs dropdown-pd-none">
            <div class="col-auto px-1 mb-2">
              <button
                mat-stroked-button
                color="primary"
                *ngIf="form.data['id'] && form.data['id'] > 0"
                (click)="
                  openAttributeModal();
                  atribForm['data']['values'] = [];
                  tempAttributeValue = '';
                  tempKey = '';
                  tempMapValue = ''
                "
                matTooltip="{{ 'ATTRIBUTES.ADD_ATTRIBUTE' | translate }}"
                data-bs-toggle="modal"
                data-bs-target="#attribModel"
              >
                <mat-icon>add</mat-icon>
                {{ "COMMON.ADD" | translate }}
              </button>
            </div>

            <div class="col-md-2 col-auto px-2 mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{
                  "ATTRIBUTES.SEARCH_PLACEHOLDER" | translate
                }}</mat-label>
                <input
                  matInput
                  [(ngModel)]="searchAttributeItem"
                  type="text"
                  id="searchAttributeInput"
                  name="searchAttribute"
                />
              </mat-form-field>
            </div>

            <div class="col-auto px-1 mb-2">
              <div class="btn-group shadow-sm bg-white-gp rounded" role="group">
                <button
                  (click)="setAttribFilter('unique')"
                  type="button"
                  class="btn btn-outline-secondary border-0"
                  matTooltip="{{ 'ATTRIBUTES.SEARCH_UNIQUE' | translate }}"
                  matTooltipPosition="above"
                >
                  <i class="bx bxs-bulb"></i>
                </button>
                <button
                  (click)="setAttribFilter('index')"
                  type="button"
                  class="btn btn-outline-secondary border-0"
                  matTooltip="{{ 'ATTRIBUTES.SEARCH_INDEX' | translate }}"
                  matTooltipPosition="above"
                >
                  <i class="fa fa-info"></i>
                </button>
                <button
                  (click)="setAttribFilter('required')"
                  type="button"
                  class="btn btn-outline-secondary border-0"
                  matTooltip="{{ 'ATTRIBUTES.SEARCH_REQUIRED' | translate }}"
                  matTooltipPosition="above"
                >
                  <i class="fa fa-asterisk"></i>
                </button>
                <button
                  (click)="setAttribFilter('system')"
                  type="button"
                  class="btn btn-outline-secondary border-0"
                  matTooltip="{{ 'ATTRIBUTES.SEARCH_SYSTEM' | translate }}"
                  matTooltipPosition="above"
                >
                  <i class="bx bxs-cog"></i>
                </button>
                <button
                  (click)="setAttribFilter('sequence')"
                  type="button"
                  class="btn btn-outline-secondary border-0"
                  matTooltip="{{ 'ATTRIBUTES.SEARCH_SEQUENCE' | translate }}"
                  matTooltipPosition="above"
                >
                  <i class="bx bx-right-top-arrow-circle"></i>
                </button>

                <button
                  (click)="setAttribFilter(''); searchAttributeItem = ''"
                  type="button"
                  class="btn btn-outline-secondary border-0"
                  matTooltip="{{ 'ATTRIBUTES.SEARCH_RESET' | translate }}"
                  matTooltipPosition="above"
                >
                  <i class="fa fa-eraser"></i>
                </button>
              </div>
            </div>

            <div class="col-auto px-1 mb-2">
              <button
                mat-stroked-button
                type="button"
                color="primary"
                *ngIf="form.data['id'] && form.data['id'] > 0"
                (click)="downloadUserAttribute()"
                [matTooltip]="'ATTRIBUTES.DOWNLOAD_CSV' | translate"
                matTooltipPosition="above"
              >
                <mat-icon>download</mat-icon>
                {{ "ATTRIBUTES.DOWNLOAD_CSV" | translate }}
              </button>
            </div>

            <div class="col-auto px-1 mb-2">
              <input
                type="file"
                #fileInput
                hidden
                (change)="onCsvFileUpload($event); fileInput.value = ''"
                accept=".csv"
              />
              <button
                mat-stroked-button
                type="button"
                color="primary"
                *ngIf="form.data['id'] && form.data['id'] > 0"
                (click)="fileInput.click()"
                [matTooltip]="'ATTRIBUTES.UPLOAD_CSV' | translate"
                matTooltipPosition="above"
              >
                <mat-icon>upload</mat-icon>
                {{ "ATTRIBUTES.UPLOAD_CSV" | translate }}
              </button>
            </div>

            <div class="col-auto px-1 mb-2">
              <button
                mat-stroked-button
                type="button"
                color="primary"
                (click)="downloadSampleCsv()"
                [matTooltip]="'ATTRIBUTES.SAMPLE_CSV' | translate"
                matTooltipPosition="above"
              >
                <mat-icon>description</mat-icon>
                {{ "ATTRIBUTES.SAMPLE_CSV" | translate }}
              </button>
            </div>
          </div>
        </div>
        <div class="card-body pt-0">
          <p *ngIf="form['searchError'] == false && form['searchMessage']">
            <app-ncs-alert [message]="form['searchMessage']" type="success" />
          </p>
          <p *ngIf="form['searchError'] == true && form['searchMessage']">
            <app-ncs-alert [message]="form['searchMessage']" type="danger" />
          </p>
          <div class="table-container shadow-sm border rounded">
            <div
              class="table-responsive"
              style="max-height: 450px; overflow-y: auto"
            >
              <table class="table table-bordered table-hover">
                <thead
                  class="table-light sticky-top"
                  style="top: 0; z-index: 1"
                >
                  <tr>
                    <th>{{ "COMMON.SNO" | translate }}</th>
                    <th>{{ "ATTRIBUTES.LABEL" | translate }}</th>
                    <th>{{ "COMMON.CODE" | translate }}</th>
                    <th>{{ "ATTRIBUTES.TYPE" | translate }}</th>
                    <th>{{ "ATTRIBUTES.DEFINE" | translate }}</th>
                    <th>{{ "COMMON.DESCRIPTION" | translate }}</th>
                    <th>{{ "ATTRIBUTES.VERSION" | translate }}</th>
                    <th>{{ "ATTRIBUTES.CREATED_DATE" | translate }}</th>
                    <th>{{ "COMMON.ACTIONS" | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let e of filterAttributesByLabelType();
                      let i = index
                    "
                    draggable="true"
                    class="draggable-row"
                    (dragstart)="onDragStart($event, e, i)"
                    (dragover)="onDragOver($event, e, i)"
                    (drop)="onDrop($event, e, i)"
                    (dragend)="onDragEnd($event, e)"
                  >
                    <td class="text-muted fw-bold">
                      <i
                        class="fas fa-grip-vertical me-2 text-light-emphasis"
                      ></i>
                      {{ i + 1 }}
                    </td>
                    <td>
                      <span class="fw-semibold text-dark">{{
                        e["label"]
                      }}</span>
                    </td>
                    <td>
                      <div class="text-primary fw-bold small">
                        {{ e["code"] }}
                      </div>
                      <div class="text-muted extra-small">
                        {{ e["size"] }}
                        <span
                          *ngIf="e['type'] !== 'date' && e['type'] !== 'idate'"
                        >
                          / {{ e["min"] }}/ {{ e["max"] }}
                        </span>
                        <span
                          *ngIf="e['type'] === 'date' || e['type'] === 'idate'"
                        >
                          {{ e["minDate"] }} / {{ e["maxDate"] }}</span
                        >
                      </div>
                    </td>
                    <td>
                      <span class="badge bg-light text-dark border">{{
                        "attributeslabel." + e.type | translate
                      }}</span>
                    </td>
                    <td>
                      <div class="d-flex gap-1 fs-5">
                        <a
                          *ngIf="e['unique'] == 1"
                          [title]="'ATTRIBUTES.UNIQUE' | translate"
                          class="text-warning"
                        >
                          <i class="bx bxs-bulb"></i>
                        </a>
                        <a
                          *ngIf="e['index'] == 1"
                          [title]="'ATTRIBUTES.INDEX' | translate"
                          class="text-info"
                        >
                          <i
                            class="fas fa-info-circle"
                            style="font-size: 14px"
                          ></i>
                        </a>
                        <a
                          *ngIf="e['required'] == 1"
                          [title]="'ATTRIBUTES.REQUIRED' | translate"
                          class="text-danger"
                        >
                          <i
                            class="fas fa-asterisk"
                            style="font-size: 10px"
                          ></i>
                        </a>
                        <a
                          *ngIf="e['system'] == 1"
                          [title]="'ATTRIBUTES.SYSTEM' | translate"
                          class="text-secondary"
                        >
                          <i class="bx bxs-cog"></i>
                        </a>
                        <a
                          *ngIf="e['sequence'] == 1 && e['sequenceId']"
                          title="{{ 'ATTRIBUTES.SEQUENCE' | translate }}"
                          class="text-secondary"
                        >
                          <i class="bx bx-right-top-arrow-circle"></i>
                        </a>
                      </div>
                    </td>
                    <td [title]="getDescription(e)" class="text-truncate">
                      {{ e["description"] | truncate }}
                    </td>
                    <td>{{ e["version"] }}</td>
                    <td class="small">
                      {{ e["createdDatetime"] | date: "dd-MM-yyyy" }}<br />
                      <span class="text-muted">{{
                        e["createdDatetime"] | date: "hh:mm a"
                      }}</span>
                    </td>
                    <td>
                      <!-- <div class="d-flex gap-1 flex-wrap">
                                                <button *ngIf="editCheck(e)" type="button"
                                                    class="btn btn-sm btn-outline-primary border-0"
                                                    [title]="'COMMON.EDIT' | translate" (click)="getAttribute(e['id'])"
                                                    data-bs-toggle="modal" data-bs-target="#attribModel">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button *ngIf="checkParent(e)" type="button"
                                                    class="btn btn-sm btn-outline-danger border-0"
                                                    [title]="'COMMON.DELETE' | translate"
                                                    (click)="this.deleteAttribute(e['id'])">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </div> -->
                      <div class="d-flex gap-1">
                        <button
                          mat-stroked-button
                          *ngIf="editCheck(e)"
                          color="primary"
                          type="button"
                          class="icon-center icon-width"
                          [matTooltip]="'COMMON.EDIT' | translate"
                          (click)="getAttribute(e['id'])"
                          data-bs-toggle="modal"
                          data-bs-target="#attribModel"
                        >
                          <mat-icon class="icon-compact">edit</mat-icon>
                        </button>

                        <button
                          mat-stroked-button
                          *ngIf="checkParent(e)"
                          color="warn"
                          type="button"
                          class="icon-center icon-width"
                          [matTooltip]="'COMMON.DELETE' | translate"
                          (click)="this.deleteAttribute(e['id'])"
                        >
                          <mat-icon class="icon-compact">delete</mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 px-1">
      <div class="card border-0 shadow-sm">
        <div class="card-header">
          <div class="d-flex gap-3 align-items-center justify-content-between">
            <h5 class="m-0">{{ "APPLICATIONS.API_RULES" | translate }}</h5>
            <button
              mat-stroked-button
              color="primary"
              data-bs-toggle="modal"
              data-bs-target="#addRule"
              (click)="resetRuleDataForm()"
            >
              <mat-icon class="me-1">add</mat-icon>
              {{ "RULES.ADD_RULE" | translate }}
            </button>
          </div>
        </div>

        <div class="card-body">
          <div class="table-container">
            <div
              class="table-responsive"
              style="max-height: 450px; overflow-y: auto"
            >
              <table class="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th style="width: 5%" class="text-center">
                      {{ "COMMON.SNO" | translate }}
                    </th>
                    <th>{{ "RULES.SELECT_EVENT" | translate }}</th>
                    <th>{{ "RULES.RULE_LOGIC" | translate }}</th>
                    <th>{{ "COMMON.ACTIONS" | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let key of ruleList; let i = index">
                    <td style="width: 5%" class="text-center">{{ i + 1 }}</td>
                    <td>{{ key.event }}</td>
                    <td class="textarea-container">
                      <!-- <textarea class="form-control form-control-sm" rows="2"
                                                readonly>{{ key.rule }}</textarea> -->
                      <mat-form-field appearance="outline" class="w-100">
                        <textarea matInput readonly rows="3">{{
                          key.rule
                        }}</textarea>
                      </mat-form-field>
                    </td>
                    <td>
                      <div class="d-flex gap-2 align-items-center">
                        <button
                          mat-stroked-button
                          color="primary"
                          class="icon-center icon-width"
                          (click)="openRuleEditModal(key.id)"
                          [matTooltip]="'COMMON.EDIT' | translate"
                        >
                          <mat-icon class="icon-compact">edit</mat-icon>
                        </button>

                        <button
                          mat-stroked-button
                          color="warn"
                          class="icon-center icon-width"
                          (click)="deleteRule(key.id)"
                          [matTooltip]="'COMMON.DELETE' | translate"
                        >
                          <mat-icon class="icon-compact">delete</mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Add attribute Modal -->
<div
  class="modal fade"
  id="attribModel"
  tabindex="-1"
  aria-labelledby="attribModelLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title" id="attribModelLabel">
          {{
            "ATTRIBUTES.MODAL.TITLE" | translate: { name: form.data["name"] }
          }}
        </h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
        ></button>
      </div>

      <div class="modal-body">
        <form
          class="form-horizontal compact-inputs"
          role="form"
          #uiForm="ngForm"
        >
          <p *ngIf="atribForm['error'] == false && atribForm['message']">
            <app-ncs-alert [message]="atribForm['message']" type="success" />
          </p>
          <p *ngIf="atribForm['error'] == true && atribForm['message']">
            <app-ncs-alert [message]="atribForm['message']" type="danger" />
          </p>

          <ul class="nav nav-tabs mb-2" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="basic-tab"
                data-bs-toggle="tab"
                data-bs-target="#basic-tab-pane"
                type="button"
                role="tab"
                aria-controls="basic-tab-pane"
                aria-selected="true"
                [class.active]="activeTab === 'basic'"
                (click)="setTab('basic')"
              >
                {{ "ATTRIBUTES.MODAL.TABS.BASIC" | translate }}
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="advance-tab"
                data-bs-toggle="tab"
                data-bs-target="#advance-tab-pane"
                type="button"
                role="tab"
                aria-controls="advance-tab-pane"
                aria-selected="false"
                [class.active]="activeTab === 'advance'"
                (click)="setTab('advance')"
              >
                {{ "ATTRIBUTES.MODAL.TABS.ADVANCED" | translate }}
              </button>
            </li>
          </ul>

          <div class="tab-content" id="myTabContent">
            <div
              class="tab-pane fade show active"
              id="basic-tab-pane"
              role="tabpanel"
              aria-labelledby="basic-tab"
              tabindex="0"
              [class.show]="activeTab === 'basic'"
              [class.active]="activeTab === 'basic'"
              *ngIf="activeTab === 'basic'"
            >
              <div class="form-row mb-2">
                <label
                  for="label"
                  class="col-sm-1 col-form-label col-form-label-sm"
                >
                  {{ "ATTRIBUTES.MODAL.FIELDS.LABEL" | translate }}
                </label>
                <div class="col">
                  <mat-form-field
                    appearance="outline"
                    class="w-100"
                    subscriptSizing="dynamic"
                  >
                    <input
                      matInput
                      id="label"
                      name="label"
                      type="text"
                      [(ngModel)]="this.atribForm['data']['label']"
                      (input)="checkValue($event)"
                      [placeholder]="
                        'ATTRIBUTES.MODAL.FIELDS.LABEL_PLACEHOLDER' | translate
                      "
                      pattern="[a-zA-Z][a-zA-Z ]+"
                      required
                    />

                    <mat-error *ngIf="atribForm?.inputerror?.label">
                      {{ atribForm.inputerror.label }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <p class="mt-2 code-text">
                  {{ "COMMON.CODE" | translate }}:{{
                    atribForm["data"]["code"]
                  }}
                </p>
              </div>

              <div class="form-row mb-2">
                <label
                  for="type"
                  class="col-sm-1 col-form-label col-form-label-sm"
                >
                  {{ "ATTRIBUTES.MODAL.FIELDS.TYPE" | translate }}
                </label>
                <div class="col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select
                      [(ngModel)]="atribForm['data']['type']"
                      id="type"
                      name="type"
                      placeholder="{{
                        'ATTRIBUTES.MODAL.FIELDS.SELECT_TYPE' | translate
                      }}"
                      required
                    >
                      <mat-option [value]="undefined" disabled>
                        {{ "ATTRIBUTES.MODAL.FIELDS.SELECT_TYPE" | translate }}
                      </mat-option>
                      <mat-option
                        *ngFor="let option of attributeTypes"
                        [value]="option.value"
                      >
                        {{ option.icon }} {{ option.label | translate }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="col" *ngIf="showSizeINMBField()">
                <label for="size" class="col-form-label col-form-label-sm">
                  {{ "ATTRIBUTES.MODAL.FIELDS.SIZE_IN_MB" | translate }}
                </label>
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    [(ngModel)]="atribForm['data']['size']"
                    id="size"
                    name="size"
                    type="number"
                    min="0"
                    [placeholder]="'ATTRIBUTES.MODAL.FIELDS.SIZE' | translate"
                    aria-label="Size"
                  />
                </mat-form-field>
              </div>

              <div class="col" *ngIf="showSizeField()">
                <label for="size" class="col-form-label col-form-label-sm">
                  {{ "ATTRIBUTES.MODAL.FIELDS.SIZE" | translate }}
                </label>
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    [(ngModel)]="atribForm['data']['size']"
                    id="size"
                    name="size"
                    type="number"
                    min="0"
                    [placeholder]="'ATTRIBUTES.MODAL.FIELDS.SIZE' | translate"
                  />
                </mat-form-field>
              </div>

              <div
                *ngIf="this.atribForm['data']['type'] === 'expression'"
                class="mb-2"
              >
                <div class="row dropdown-pd-none">
                  <div class="col">
                    <label for="expression">
                      {{ "ATTRIBUTES.MODAL.FIELDS.EXPRESSION" | translate }}
                    </label>
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        id="expression"
                        name="expression"
                        [(ngModel)]="atribForm['data']['expression']"
                        #expression="ngModel"
                        required
                        type="text"
                        [placeholder]="
                          'ATTRIBUTES.MODAL.FIELDS.EXPRESSION_PLACEHOLDER'
                            | translate
                        "
                        (input)="filterOptions(); onInputChange1()"
                        (blur)="onBlur1()"
                        (keypress)="onKeyPress($event)"
                      />
                    </mat-form-field>

                    <div *ngIf="showPopup1" class="popup-container">
                      <mat-card
                        class="dropdown-card"
                        *ngIf="filteredOptions.length > 0"
                      >
                        <mat-list role="list">
                          <mat-list-item
                            *ngFor="let option of filteredOptions"
                            role="listitem"
                            (click)="selectOption1(option)"
                            class="custom-option"
                          >
                            {{ option["label"] }}
                          </mat-list-item>
                        </mat-list>
                      </mat-card>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col mt-2">
                    <label
                      for="placeValue"
                      class="col col-form-label col-form-label-sm"
                    >
                      {{ "ATTRIBUTES.MODAL.FIELDS.PLACE_VALUE" | translate }}
                    </label>
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        [(ngModel)]="this.atribForm['data']['placeValue']"
                        id="placeValue"
                        name="placeValue"
                        type="number"
                        [value]="0"
                        [min]="0"
                        placeholder="{{
                          'ATTRIBUTES.MODAL.FIELDS.PLACE_VALUE' | translate
                        }}"
                        aria-label="placeValue"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div
                class="row"
                *ngIf="this.atribForm['data']['type'] === 'date'"
              >
                <div class="col-md-6 mb-2">
                  <label for="minDate" class="col-form-label col-form-label-sm">
                    {{ "ATTRIBUTES.MODAL.FIELDS.START_DATE" | translate }}
                  </label>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                  >
                    <input
                      matInput
                      [(ngModel)]="this.atribForm['data']['minDate']"
                      id="minDate"
                      name="minDate"
                      type="date"
                      [max]="this.atribForm['data']['maxDate']"
                      [placeholder]="
                        'ATTRIBUTES.MODAL.FIELDS.START_DATE' | translate
                      "
                      aria-label="minDate"
                      #minDatePicker
                    />
                    <button
                      mat-icon-button
                      matSuffix
                      type="button"
                      class="icon-pd-none"
                      (click)="minDatePicker.showPicker()"
                      aria-label="Open date picker"
                    >
                      <mat-icon class="icon-compact text-secondary"
                        >calendar_today</mat-icon
                      >
                    </button>
                  </mat-form-field>
                </div>

                <div class="col-md-6 mb-2">
                  <label for="maxDate" class="col-form-label col-form-label-sm">
                    {{ "ATTRIBUTES.MODAL.FIELDS.END_DATE" | translate }}
                  </label>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                  >
                    <input
                      matInput
                      [(ngModel)]="this.atribForm['data']['maxDate']"
                      id="maxDate"
                      name="maxDate"
                      type="date"
                      [min]="this.atribForm['data']['minDate']"
                      [placeholder]="
                        'ATTRIBUTES.MODAL.FIELDS.END_DATE' | translate
                      "
                      aria-label="maxDate"
                      #maxDatePicker
                    />
                    <button
                      mat-icon-button
                      matSuffix
                      type="button"
                      class="icon-pd-none"
                      (click)="maxDatePicker.showPicker()"
                      aria-label="Open date picker"
                    >
                      <mat-icon class="icon-compact text-secondary"
                        >calendar_today</mat-icon
                      >
                    </button>
                  </mat-form-field>
                </div>
              </div>

              <div class="row mt-2" *ngIf="atribForm?.data?.type === 'date'">
                <div class="col">
                  <div class="d-flex align-items-center">
                    <div>
                      <mat-checkbox
                        id="defaultToCurrentDate"
                        name="defaultToCurrentDate"
                        color="primary"
                        [(ngModel)]="atribForm['data']['defaultToCurrentDate']"
                        (change)="
                          toggleVal(
                            atribForm['data']['defaultToCurrentDate'],
                            atribForm['data'],
                            'defaultToCurrentDate'
                          )
                        "
                        class="mb-2"
                      >
                        {{
                          "ATTRIBUTES.MODAL.FIELDS.DEFAULT_TO_CURRENT_DATE"
                            | translate
                        }}
                      </mat-checkbox>
                    </div>
                    <mat-icon
                      class="icon-compact text-secondary ms-2 mb-2"
                      [matTooltip]="
                        'ATTRIBUTES.MODAL.TOOLTIPS.DEFAULT_TO_CURRENT_DATE'
                          | translate
                      "
                      >info</mat-icon
                    >
                  </div>
                </div>
              </div>

              <div
                class="row"
                *ngIf="this.atribForm['data']['type'] === 'idate'"
              >
                <!-- Start-Date -->
                <div class="col-md-6 mb-2">
                  <label
                    for="iminDate"
                    class="col-form-label col-form-label-sm"
                  >
                    {{ "ATTRIBUTES.MODAL.FIELDS.START_DATE" | translate }}
                  </label>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                  >
                    <input
                      matInput
                      [(ngModel)]="this.atribForm['data']['minDate']"
                      id="iminDate"
                      name="iminDate"
                      type="date"
                      [max]="this.atribForm['data']['maxDate']"
                      [placeholder]="
                        'ATTRIBUTES.MODAL.FIELDS.START_DATE' | translate
                      "
                      aria-label="iminDate"
                      #iminDatePicker
                    />
                    <button
                      mat-icon-button
                      matSuffix
                      type="button"
                      class="icon-pd-none"
                      (click)="iminDatePicker.showPicker()"
                      aria-label="Open date picker"
                    >
                      <mat-icon class="icon-compact text-secondary"
                        >calendar_today</mat-icon
                      >
                    </button>
                  </mat-form-field>
                </div>

                <!-- End-Date -->
                <div class="col-md-6 mb-2">
                  <label
                    for="imaxDate"
                    class="col-form-label col-form-label-sm"
                  >
                    {{ "ATTRIBUTES.MODAL.FIELDS.END_DATE" | translate }}
                  </label>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                  >
                    <input
                      matInput
                      [(ngModel)]="this.atribForm['data']['maxDate']"
                      id="imaxDate"
                      name="imaxDate"
                      type="date"
                      [min]="this.atribForm['data']['minDate']"
                      [placeholder]="
                        'ATTRIBUTES.MODAL.FIELDS.END_DATE' | translate
                      "
                      aria-label="imaxDate"
                      #imaxDatePicker
                    />
                    <button
                      mat-icon-button
                      matSuffix
                      type="button"
                      class="icon-pd-none"
                      (click)="imaxDatePicker.showPicker()"
                      aria-label="Open date picker"
                    >
                      <mat-icon class="icon-compact text-secondary"
                        >calendar_today</mat-icon
                      >
                    </button>
                  </mat-form-field>
                </div>
              </div>

              <div class="row mt-2" *ngIf="atribForm?.data?.type === 'idate'">
                <div class="col">
                  <div class="d-flex align-items-center">
                    <div>
                      <mat-checkbox
                        id="idefaultToCurrentDate"
                        name="idefaultToCurrentDate"
                        color="primary"
                        [(ngModel)]="atribForm['data']['defaultToCurrentDate']"
                        (change)="
                          toggleVal(
                            atribForm['data']['defaultToCurrentDate'],
                            atribForm['data'],
                            'defaultToCurrentDate'
                          )
                        "
                        class="mb-2"
                      >
                        {{
                          "ALLREMAININGS.IDEFAULT_TO_CURRENT_DATE" | translate
                        }}
                      </mat-checkbox>
                    </div>
                    <mat-icon
                      class="icon-compact text-secondary ms-2 mb-2"
                      [matTooltip]="
                        'ATTRIBUTES.MODAL.ITOOLTIPS.DEFAULT_TO_CURRENT_DATE'
                          | translate
                      "
                    >
                      info
                    </mat-icon>
                  </div>
                </div>
              </div>

              <div
                class="row"
                *ngIf="this.atribForm['data']['type'] === 'json'"
              >
                <div class="col">
                  <label
                    class="col-form-label col-form-label-sm"
                    for="jsonDefault"
                  >
                    {{ "ATTRIBUTES.MODAL.FIELDS.DEFAULT_JSON" | translate }}
                  </label>

                  <textarea
                    [(ngModel)]="atribForm['data']['defaultValue']"
                    class="form-control form-control-sm font-monospace"
                    id="jsonDefault"
                    name="jsonDefault"
                    rows="5"
                    placeholder='{ "key": "value" }'
                  >
                  </textarea>
                </div>
              </div>

              <div
                class="row mt-2"
                *ngIf="atribForm?.data?.type === 'dateandtime'"
              >
                <div class="col">
                  <div class="d-flex align-items-center">
                    <div>
                      <mat-checkbox
                        id="defaultToCurrentDateAndTime"
                        name="defaultToCurrentDateAndTime"
                        color="primary"
                        [(ngModel)]="
                          atribForm['data']['defaultToCurrentDateAndTime']
                        "
                        (change)="
                          toggleVal(
                            atribForm['data']['defaultToCurrentDateAndTime'],
                            atribForm['data'],
                            'defaultToCurrentDateAndTime'
                          )
                        "
                        class="mb-2"
                      >
                        {{
                          "ATTRIBUTES.MODAL.FIELDS.DEFAULT_TO_CURRENT_DATE"
                            | translate
                        }}
                      </mat-checkbox>
                    </div>
                    <mat-icon
                      class="icon-compact text-secondary ms-2 mb-2"
                      [matTooltip]="
                        'ATTRIBUTES.MODAL.TOOLTIPS.DEFAULT_TO_CURRENT_DATE'
                          | translate
                      "
                    >
                      info
                    </mat-icon>
                  </div>
                </div>
              </div>

              <div class="row mt-2" *ngIf="atribForm?.data?.type === 'time'">
                <div class="col">
                  <div class="d-flex align-items-center">
                    <div>
                      <mat-checkbox
                        id="defaultToCurrentTime"
                        name="defaultToCurrentTime"
                        color="primary"
                        [(ngModel)]="atribForm['data']['defaultToCurrentTime']"
                        (change)="
                          toggleVal(
                            atribForm['data']['defaultToCurrentTime'],
                            atribForm['data'],
                            'defaultToCurrentTime'
                          )
                        "
                        class="mb-2"
                      >
                        {{
                          "ATTRIBUTES.MODAL.FIELDS.DEFAULT_TO_CURRENT_TIME"
                            | translate
                        }}
                      </mat-checkbox>
                    </div>
                    <mat-icon
                      class="icon-compact text-secondary ms-2 mb-2"
                      [matTooltip]="
                        'ATTRIBUTES.MODAL.TOOLTIPS.DEFAULT_TO_CURRENT_TIME'
                          | translate
                      "
                    >
                      info
                    </mat-icon>
                  </div>
                </div>
              </div>

              <div class="row mt-2" *ngIf="atribForm?.data?.type === 'itime'">
                <div class="col">
                  <div class="d-flex align-items-center">
                    <div>
                      <mat-checkbox
                        id="defaultToCurrentItime"
                        name="defaultToCurrentItime"
                        color="primary"
                        [(ngModel)]="atribForm['data']['defaultToCurrentItime']"
                        (change)="
                          toggleVal(
                            atribForm['data']['defaultToCurrentItime'],
                            atribForm['data'],
                            'defaultToCurrentItime'
                          )
                        "
                        class="mb-2"
                      >
                        {{
                          "ATTRIBUTES.MODAL.FIELDS.DEFAULT_TO_CURRENT_TIME"
                            | translate
                        }}
                      </mat-checkbox>
                    </div>
                    <mat-icon
                      class="icon-compact text-secondary ms-2 mb-2"
                      [matTooltip]="
                        'ATTRIBUTES.MODAL.TOOLTIPS.DEFAULT_TO_CURRENT_TIME'
                          | translate
                      "
                    >
                      info
                    </mat-icon>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="isConditionMet()">
                <!-- Size Field -->
                <div class="col-xl-3 col-lg-6 col-md-12 mb-2">
                  <label>{{
                    "ATTRIBUTES.MODAL.FIELDS.SIZE" | translate
                  }}</label>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <input
                      matInput
                      [(ngModel)]="this.atribForm['data']['size']"
                      id="size"
                      placeholder="{{
                        'ATTRIBUTES.MODAL.FIELDS.SIZE' | translate
                      }}"
                      name="size"
                      type="number"
                      [value]="0"
                      [min]="0"
                      aria-label="Size"
                    />
                  </mat-form-field>
                </div>

                <!-- Min Field -->
                <div class="col-xl-3 col-lg-6 col-md-12 mb-2">
                  <label>{{ "ATTRIBUTES.MODAL.FIELDS.MIN" | translate }}</label>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <input
                      matInput
                      [(ngModel)]="this.atribForm['data']['min']"
                      id="min"
                      name="min"
                      placeholder="{{
                        'ATTRIBUTES.MODAL.FIELDS.MIN' | translate
                      }}"
                      type="number"
                      [value]="0"
                      [min]="0"
                      aria-label="min"
                    />
                  </mat-form-field>
                </div>

                <!-- Max Field -->
                <div class="col-xl-3 col-lg-6 col-md-12 mb-2">
                  <label>{{ "ATTRIBUTES.MODAL.FIELDS.MAX" | translate }}</label>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <input
                      matInput
                      [(ngModel)]="this.atribForm['data']['max']"
                      id="max"
                      name="max"
                      placeholder="{{
                        'ATTRIBUTES.MODAL.FIELDS.MAX' | translate
                      }}"
                      type="number"
                      [value]="0"
                      [min]="0"
                      aria-label="max"
                    />
                  </mat-form-field>
                </div>

                <!-- Place Value Field (only for decimal type) -->
                <div
                  class="col-xl-3 col-lg-6 col-md-12 mb-2"
                  *ngIf="this.atribForm['data']['type'] === 'decimal'"
                >
                  <label>{{
                    "ATTRIBUTES.MODAL.FIELDS.PLACE_VALUE" | translate
                  }}</label>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <input
                      matInput
                      [(ngModel)]="this.atribForm['data']['placeValue']"
                      id="placeValue"
                      name="placeValue"
                      type="number"
                      [value]="0"
                      [min]="0"
                      aria-label="placeValue"
                      placeholder="{{
                        'ATTRIBUTES.MODAL.FIELDS.PLACE_VALUE' | translate
                      }}"
                    />
                  </mat-form-field>
                </div>

                <!-- Row Field (only for textarea type) -->
                <div
                  class="col-xl-3 col-lg-6 col-md-12 mb-2"
                  *ngIf="this.atribForm['data']['type'] === 'textarea'"
                >
                  <label>{{ "ATTRIBUTES.MODAL.FIELDS.ROW" | translate }}</label>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <input
                      matInput
                      [(ngModel)]="atribForm['data']['row']"
                      type="number"
                      id="row"
                      name="row"
                      [value]="0"
                      [min]="0"
                      placeholder="{{
                        'ATTRIBUTES.MODAL.FIELDS.ROW' | translate
                      }}"
                      aria-label="row"
                    />
                  </mat-form-field>
                </div>
              </div>

              <div class="form-row my-2" *ngIf="showDefaultValueField()">
                <div class="col mb-2">
                  <label>
                    {{ "ATTRIBUTES.MODAL.FIELDS.DEFAULT_VALUE" | translate }}
                    <i
                      class="bi bi-info-circle ms-1"
                      [matTooltip]="
                        'ATTRIBUTES.MODAL.TOOLTIPS.DEFAULT_VALUE' | translate
                      "
                      matTooltipPosition="above"
                    ></i>
                  </label>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <input
                      matInput
                      type="text"
                      id="defaultValue"
                      name="defaultValue"
                      [(ngModel)]="atribForm['data']['defaultValue']"
                      [placeholder]="
                        'ATTRIBUTES.MODAL.FIELDS.DEFAULT_VALUE' | translate
                      "
                      (blur)="validateDefaultValue()"
                    />
                  </mat-form-field>

                  <!-- Error Message -->
                  <div *ngIf="defaultValueError" class="text-danger mt-1">
                    {{ defaultValueError }}
                  </div>
                </div>
              </div>

              <div
                class="row"
                *ngIf="
                  atribForm['data']['type'] === 'text' ||
                  atribForm['data']['type'] === 'number'
                "
              >
                <div class="col">
                  <div class="d-flex align-items-center mb-2">
                    <label class="col-form-label col-form-label-sm me-2 mb-0">
                      {{ "ATTRIBUTES.MODAL.FIELDS.CODE_TYPE" | translate }}
                    </label>
                  </div>

                  <mat-radio-group
                    name="codeType"
                    [(ngModel)]="atribForm['data']['codeType']"
                    class="d-flex flex-wrap gap-3"
                  >
                    <mat-radio-button
                      color="primary"
                      id="none"
                      value="none"
                      class="me-3"
                      [checked]="true"
                    >
                      {{ "ATTRIBUTES.MODAL.FIELDS.CODE_TYPE_NONE" | translate }}
                    </mat-radio-button>
                    <mat-radio-button
                      color="primary"
                      id="qrCode"
                      value="qr"
                      class="me-3"
                    >
                      {{ "ATTRIBUTES.MODAL.FIELDS.CODE_TYPE_QR" | translate }}
                    </mat-radio-button>
                    <mat-radio-button
                      color="primary"
                      id="barCode"
                      value="bar"
                      class="me-3"
                    >
                      {{ "ATTRIBUTES.MODAL.FIELDS.CODE_TYPE_BAR" | translate }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <hr />
                </div>
              </div>
              <div class="row d-flex flex-wrap align-items-center">
                <!-- Required Checkbox -->
                <div
                  class="col-xl-4 col-lg-6 col-md-12"
                  *ngIf="this.atribForm['data']['type'] !== 'file'"
                >
                  <label
                    class="d-flex align-items-center me-3 mb-2"
                    style="cursor: pointer"
                  >
                    <input
                      type="checkbox"
                      [(ngModel)]="atribForm['data']['required']"
                      id="required"
                      name="required"
                      class="me-2"
                      (ngModelChange)="
                        this.toggleVal(
                          atribForm['data']['required'],
                          atribForm['data'],
                          'required'
                        )
                      "
                      style="width: 18px; height: 18px"
                    />
                    <span class="mb-0">
                      {{ "ATTRIBUTES.MODAL.OPTIONS.IS_REQUIRED" | translate }}
                    </span>
                  </label>
                </div>
                <!-- Index Checkbox -->
                <div class="col-xl-4 col-lg-6 col-md-12">
                  <label
                    class="d-flex align-items-center me-3 mb-2"
                    style="cursor: pointer"
                  >
                    <input
                      type="checkbox"
                      [(ngModel)]="atribForm['data']['index']"
                      id="index"
                      name="index"
                      class="me-2"
                      (ngModelChange)="
                        this.toggleVal(
                          atribForm['data']['index'],
                          atribForm['data'],
                          'index'
                        )
                      "
                      [ngModelOptions]="{ standalone: true }"
                      style="width: 18px; height: 18px"
                    />
                    <span class="mb-0">
                      {{ "ATTRIBUTES.MODAL.OPTIONS.CREATE_INDEX" | translate }}
                    </span>
                  </label>
                </div>
                <!-- Unique Checkbox -->
                <div class="col-xl-4 col-lg-6 col-md-12">
                  <label
                    class="d-flex align-items-center me-3 mb-2"
                    style="cursor: pointer"
                  >
                    <input
                      type="checkbox"
                      [(ngModel)]="atribForm['data']['unique']"
                      id="unique"
                      name="unique"
                      class="me-2"
                      [disabled]="atribForm['data']['disable']"
                      (ngModelChange)="
                        this.toggleVal(
                          atribForm['data']['unique'],
                          atribForm['data'],
                          'unique'
                        )
                      "
                      [ngModelOptions]="{ standalone: true }"
                      style="width: 18px; height: 18px"
                    />
                    <span class="mb-0">
                      {{ "ATTRIBUTES.MODAL.OPTIONS.UNIQUE" | translate }}
                    </span>
                  </label>
                </div>
                <!-- System Checkbox -->
                <div class="col-xl-4 col-lg-6 col-md-12">
                  <label
                    class="d-flex align-items-center me-3 mb-2"
                    style="cursor: pointer"
                  >
                    <input
                      type="checkbox"
                      [(ngModel)]="atribForm['data']['system']"
                      id="system"
                      name="system"
                      class="me-2"
                      (ngModelChange)="
                        this.toggleVal(
                          atribForm['data']['system'],
                          atribForm['data'],
                          'system'
                        )
                      "
                      [ngModelOptions]="{ standalone: true }"
                      style="width: 18px; height: 18px"
                    />
                    <span class="mb-0">
                      {{ "ATTRIBUTES.MODAL.OPTIONS.SYSTEM" | translate }}
                    </span>
                  </label>
                </div>
                <!-- Read Only Checkbox -->
                <div class="col-xl-4 col-lg-6 col-md-12">
                  <label
                    class="d-flex align-items-center me-3 mb-2"
                    style="cursor: pointer"
                  >
                    <input
                      type="checkbox"
                      [(ngModel)]="atribForm['data']['readOnly']"
                      id="readOnly"
                      name="readOnly"
                      class="me-2"
                      (ngModelChange)="
                        this.toggleVal(
                          atribForm['data']['readOnly'],
                          atribForm['data'],
                          'readOnly'
                        )
                      "
                      [ngModelOptions]="{ standalone: true }"
                      style="width: 18px; height: 18px"
                    />
                    <span class="mb-0">
                      {{ "ATTRIBUTES.MODAL.OPTIONS.READ_ONLY" | translate }}
                    </span>
                  </label>
                </div>
                <!-- Disable Checkbox -->
                <div class="col-xl-4 col-lg-6 col-md-12">
                  <label
                    class="d-flex align-items-center me-3 mb-2"
                    style="cursor: pointer"
                  >
                    <input
                      type="checkbox"
                      [(ngModel)]="atribForm['data']['disable']"
                      id="disable"
                      name="disable"
                      class="me-2"
                      [disabled]="atribForm['data']['unique']"
                      (ngModelChange)="
                        this.toggleVal(
                          atribForm['data']['disable'],
                          atribForm['data'],
                          'disable'
                        )
                      "
                      [ngModelOptions]="{ standalone: true }"
                      style="width: 18px; height: 18px"
                    />
                    <span class="mb-0">
                      {{ "ALLREMAININGS.Disable" | translate }}
                    </span>
                  </label>
                </div>
              </div>
              <div
                class="row mt-2"
                *ngIf="this.atribForm['data']['type'] === 'list'"
              >
                <div class="d-flex align-items-center dropdown-pd-none my-2">
                  <button
                    mat-stroked-button
                    color="primary"
                    class="icon-center icon-width"
                  >
                    <!-- <mat-icon class="compact-icon">add</mat-icon> -->
                    <span>{{
                      "ATTRIBUTES.MODAL.VALUES.VALUES" | translate
                    }}</span>
                  </button>
                  <mat-form-field appearance="outline" class="w-100">
                    <input
                      matInput
                      [(ngModel)]="tempAttributeValue"
                      #attrValue
                      id="values"
                      name="values"
                      type="text"
                      [placeholder]="
                        'ATTRIBUTES.MODAL.VALUES.ENTER_VALUE' | translate
                      "
                    />
                  </mat-form-field>
                  <button
                    mat-stroked-button
                    color="primary"
                    (click)="addAttributeValue()"
                    class="icon-center icon-width"
                  >
                    <mat-icon class="compact-icon">add</mat-icon>
                    {{ "ATTRIBUTES.MODAL.VALUES.ADD_VALUE" | translate }}
                  </button>
                </div>

                <!-- List Type Radio Buttons -->
                <div class="col-12 mt-2">
                  <label>
                    {{ "ALLREMAININGS.SHOW_LIST" | translate }}
                  </label>
                  <mat-radio-group
                    name="listType"
                    [(ngModel)]="atribForm['data']['listType']"
                    class="d-flex flex-wrap"
                  >
                    <mat-radio-button
                      id="none"
                      value="none"
                      color="primary"
                      class="me-3"
                      [checked]="true"
                    >
                      {{ "ALLREMAININGS.CODE_TYPE_DROP_DOWN" | translate }}
                    </mat-radio-button>
                    <mat-radio-button
                      id="listradiobutton"
                      value="radio"
                      color="primary"
                      class="me-3"
                    >
                      {{ "ALLREMAININGS.SHOW_RADIO" | translate }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>

                <!-- Radio/Checkbox Display Options -->
                <div
                  class="row"
                  *ngIf="
                    atribForm['data']['listType'] === 'radio' ||
                    atribForm['data']['listType'] === 'checkbox'
                  "
                >
                  <div class="col-12">
                    <mat-radio-group
                      name="listTypeView"
                      [(ngModel)]="atribForm['data']['showVertical']"
                      class="d-flex flex-wrap"
                    >
                      <mat-radio-button
                        id="horizontal"
                        value="horizontal"
                        color="primary"
                        class="me-3 mb-2"
                        [checked]="true"
                      >
                        {{ "ALLREMAININGS.SHOW_HORIZON" | translate }}
                      </mat-radio-button>
                      <mat-radio-button
                        id="vertical"
                        value="vertical"
                        color="primary"
                        class="me-3 mb-2"
                      >
                        {{ "ALLREMAININGS.SHOW_VERTICAL" | translate }}
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <div class="my-2 scrollable-values">
                  <button
                    *ngFor="let e of atribForm['data']['values']"
                    (click)="removeAttribueValue(e)"
                    type="button"
                    class="btn btn-outline-secondary btn-sm value-chip me-2 mb-2"
                  >
                    <span class="truncate-text" [title]="e">{{ e }}</span>
                    <i class="fa fa-times ms-2"></i>
                  </button>
                </div>
              </div>

              <!-- Type Map -->
              <div
                class="row mt-3"
                *ngIf="this.atribForm['data']['type'] === 'map'"
              >
                <div
                  class="d-flex align-items-center flex-wrap mb-3 dropdown-pd-none gap-1"
                >
                  <!-- First Input - Key -->
                  <mat-form-field appearance="outline" class="key-field">
                    <input
                      matInput
                      [(ngModel)]="tempKey"
                      id="key"
                      name="key"
                      type="text"
                      [placeholder]="
                        'ATTRIBUTES.MODAL.VALUES.ENTER_KEY' | translate
                      "
                    />
                  </mat-form-field>
                  <!-- Second Input - Value -->
                  <mat-form-field appearance="outline" class="value-field">
                    <input
                      matInput
                      [(ngModel)]="tempMapValue"
                      id="tempMapValue"
                      name="tempMapValue"
                      type="text"
                      [placeholder]="
                        'ATTRIBUTES.MODAL.VALUES.ENTER_MAP_VALUE' | translate
                      "
                    />
                  </mat-form-field>
                  <!-- Add Button -->
                  <button
                    mat-stroked-button
                    color="primary"
                    (click)="addAttributeMapValue()"
                    class="icon-center icon-width"
                  >
                    <mat-icon class="icon-compact">add</mat-icon>
                  </button>
                </div>
                <div class="mb-3">
                  <button
                    *ngFor="let item of this.atribForm['data']['values']"
                    (click)="removeAttribueMapValue(item.key)"
                    type="button"
                    class="btn btn-outline-secondary btn-sm me-2"
                  >
                    {{ item.key }}: {{ item.value }} <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>

              <!-- Primary Usecase and Dependent Attribute -->
              <div class="row" *ngIf="atribForm['data']['refKey'] == 1">
                <!-- Primary Usecase -->
                <div class="col-md-6 mb-3">
                  <label>{{
                    "ATTRIBUTES.MODAL.VALUES.PRIMARY_USECASE" | translate
                  }}</label>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <mat-select
                      [(ngModel)]="atribForm['data']['primaryUsecase']"
                      id="primaryUsecase"
                      name="primaryUsecase"
                    >
                      <mat-option
                        *ngFor="let e of form.list"
                        [value]="e['collectionName']"
                      >
                        {{ e["name"] }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Dependent Attribute -->
                <div class="col-md-6 mb-3">
                  <label>{{
                    "ATTRIBUTES.MODAL.VALUES.DEPENDENT_ATTRIBUTE" | translate
                  }}</label>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <mat-select
                      [(ngModel)]="atribForm['data']['depAttribute']"
                      id="depAttribute"
                      name="depAttribute"
                    >
                      <mat-option
                        *ngFor="let e of filterAttributes()"
                        [value]="e['code']"
                      >
                        {{ e["label"] }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <!-- Parent Usecase Dependency -->
              <div class="row" *ngIf="atribForm['data']['refKey'] == 1">
                <div class="col-12 mb-3">
                  <label>{{
                    "ATTRIBUTES.MODAL.VALUES.PARENT_USECASE_DEPENDENCY"
                      | translate
                  }}</label>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <mat-select
                      [(ngModel)]="atribForm['data']['parentUseDependency']"
                      id="parentUsecaseDependency"
                      name="parentUsecaseDependency"
                    >
                      <mat-option *ngFor="let e of form.list" [value]="e['id']">
                        {{ e["name"] }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <!-- Parent Usecase Dependency Chips -->
                  <div class="mb-2 d-flex flex-wrap gap-2">
                    <mat-chip
                      *ngFor="
                        let e of parentUsecaseDependency | keyvalue;
                        let i = index
                      "
                      [removable]="true"
                      (removed)="removeParentUscaseDependency(e.key)"
                      class="mt-1"
                    >
                      {{ e.value["parentName"] }}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="tab-pane fade"
              id="advance-tab-pane"
              role="tabpanel"
              aria-labelledby="advance-tab"
              tabindex="0"
              [class.show]="activeTab === 'advance'"
              [class.active]="activeTab === 'advance'"
              *ngIf="activeTab === 'advance'"
            >
              <div
                class="row mt-4 mb-4"
                *ngIf="this.atribForm['data']['type'] === 'file'"
              >
                <div class="col">
                  <!-- <input [(ngModel)]="atribForm['data']['captureImage']" class="form-check-input"
                                        type="checkbox" id="captureImage" name="captureImage"
                                        (change)="this.toggleVal(atribForm['data']['captureImage'], atribForm['data'], 'captureImage')"> -->
                  <mat-checkbox
                    [(ngModel)]="atribForm['data']['captureImage']"
                    id="captureImage"
                    name="captureImage"
                    color="primary"
                    (ngModelChange)="
                      this.toggleVal(
                        atribForm['data']['captureImage'],
                        atribForm['data'],
                        'captureImage'
                      )
                    "
                  >
                  </mat-checkbox>
                  <label
                    class="form-check-label ms-1 marget"
                    for="captureImage"
                  >
                    {{ "ATTRIBUTES.MODAL.OPTIONS.ENABLE_CAMERA" | translate }}
                  </label>
                </div>
              </div>
              <div class="row" *ngIf="atribForm.data.type === 'list'">
                <div class="col">
                  <div>
                    <mat-checkbox
                      [(ngModel)]="atribForm['data']['order']"
                      id="order"
                      name="orderType"
                      color="primary"
                      (ngModelChange)="
                        toggleVal(
                          atribForm['data']['order'],
                          atribForm['data'],
                          'order'
                        )
                      "
                    >
                    </mat-checkbox>
                    <label class="form-check-label ms-1" for="order">
                      {{ "ATTRIBUTES.MODAL.OPTIONS.ORDER_LIST" | translate }}
                    </label>
                  </div>
                </div>
              </div>
              <div
                class="row mt-4"
                *ngIf="this.atribForm['data']['type'] === 'date'"
              >
                <div class="col">
                  <mat-checkbox
                    [(ngModel)]="atribForm['data']['futureDate']"
                    id="futureDate"
                    name="futureDate"
                    color="primary"
                    (ngModelChange)="
                      this.toggleVal(
                        atribForm['data']['futureDate'],
                        atribForm['data'],
                        'futureDate'
                      )
                    "
                  >
                  </mat-checkbox>
                  <label
                    class="form-check-label ms-1 marget me-2"
                    for="futureDate"
                  >
                    {{ "ATTRIBUTES.MODAL.OPTIONS.NO_FUTURE_DATE" | translate }}
                  </label>
                  <span
                    ncsTooltip
                    [matTooltip]="
                      'ATTRIBUTES.MODAL.TOOLTIPS.NO_FUTURE_DATE' | translate
                    "
                  >
                    <i class="bi bi-info-circle text-secondary"></i>
                  </span>
                </div>
              </div>
              <div
                class="row"
                *ngIf="this.atribForm['data']['type'] === 'date'"
              >
                <div class="col">
                  <mat-checkbox
                    [(ngModel)]="atribForm['data']['pastDate']"
                    id="pastDate"
                    name="pastDate"
                    color="primary"
                    (ngModelChange)="
                      this.toggleVal(
                        atribForm['data']['pastDate'],
                        atribForm['data'],
                        'pastDate'
                      )
                    "
                  >
                  </mat-checkbox>
                  <label
                    class="form-check-label ms-1 marget me-2"
                    for="pastDate"
                  >
                    {{ "ATTRIBUTES.MODAL.OPTIONS.NO_PAST_DATE" | translate }}
                  </label>
                  <span
                    ncsTooltip
                    [matTooltip]="
                      'ATTRIBUTES.MODAL.TOOLTIPS.NO_PAST_DATE' | translate
                    "
                  >
                    <i class="bi bi-info-circle text-secondary"></i>
                  </span>
                </div>
              </div>
              <div
                class="row"
                *ngIf="this.atribForm['data']['type'] === 'date'"
              >
                <div class="col">
                  <label
                    for="futureDateLimit"
                    class="col col-form-label col-form-label-sm me-2"
                  >
                    {{
                      "ATTRIBUTES.MODAL.FIELDS.FUTURE_DATE_LIMIT" | translate
                    }}
                  </label>
                  <span
                    ncsTooltip
                    [matTooltip]="
                      'ATTRIBUTES.MODAL.TOOLTIPS.FUTURE_DATE_LIMIT' | translate
                    "
                  >
                    <i class="bi bi-info-circle text-secondary"></i>
                  </span>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <input
                      matInput
                      [(ngModel)]="this.atribForm['data']['futureDateLimit']"
                      id="futureDateLimit"
                      name="futureDateLimit"
                      type="number"
                      [value]="0"
                      [min]="1"
                      [placeholder]="
                        'ATTRIBUTES.MODAL.FIELDS.FUTURE_DATE_LIMIT' | translate
                      "
                      aria-label="Future Date Limit"
                    />
                  </mat-form-field>
                </div>
                <div class="col">
                  <label
                    for="pastDateLimit"
                    class="col col-form-label col-form-label-sm me-2"
                  >
                    {{ "ATTRIBUTES.MODAL.FIELDS.PAST_DATE_LIMIT" | translate }}
                  </label>
                  <span
                    ncsTooltip
                    [matTooltip]="
                      'ATTRIBUTES.MODAL.TOOLTIPS.PAST_DATE_LIMIT' | translate
                    "
                  >
                    <i class="bi bi-info-circle text-secondary"></i>
                  </span>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <input
                      matInput
                      [(ngModel)]="this.atribForm['data']['pastDateLimit']"
                      id="pastDateLimit"
                      name="pastDateLimit"
                      type="number"
                      [value]="0"
                      [min]="1"
                      [placeholder]="
                        'ATTRIBUTES.MODAL.FIELDS.PAST_DATE_LIMIT' | translate
                      "
                      aria-label="pastDateLimit"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div
                class="row mb-2"
                *ngIf="this.atribForm['data']['type'] === 'idate'"
              >
                <div class="col">
                  <mat-checkbox
                    [(ngModel)]="atribForm['data']['futureDate']"
                    id="futureDate"
                    name="futureDate"
                    color="primary"
                    (ngModelChange)="
                      this.toggleVal(
                        atribForm['data']['futureDate'],
                        atribForm['data'],
                        'futureDate'
                      )
                    "
                  >
                  </mat-checkbox>
                  <label
                    class="form-check-label ms-1 marget me-2"
                    for="futureDate"
                  >
                    {{ "ATTRIBUTES.MODAL.OPTIONS.NO_FUTURE_DATE" | translate }}
                  </label>
                  <span
                    ncsTooltip
                    [matTooltip]="
                      'ATTRIBUTES.MODAL.TOOLTIPS.NO_FUTURE_DATE' | translate
                    "
                  >
                    <i class="bi bi-info-circle text-secondary"></i>
                  </span>
                </div>
              </div>
              <div
                class="row"
                *ngIf="this.atribForm['data']['type'] === 'idate'"
              >
                <div class="col">
                  <mat-checkbox
                    [(ngModel)]="atribForm['data']['pastDate']"
                    id="pastDate"
                    name="pastDate"
                    color="primary"
                    (ngModelChange)="
                      this.toggleVal(
                        atribForm['data']['pastDate'],
                        atribForm['data'],
                        'pastDate'
                      )
                    "
                  >
                  </mat-checkbox>
                  <label
                    class="form-check-label ms-1 marget me-2"
                    for="pastDate"
                  >
                    {{ "ATTRIBUTES.MODAL.OPTIONS.NO_PAST_DATE" | translate }}
                  </label>
                  <span
                    ncsTooltip
                    [matTooltip]="
                      'ATTRIBUTES.MODAL.TOOLTIPS.NO_PAST_DATE' | translate
                    "
                  >
                    <i class="bi bi-info-circle text-secondary"></i>
                  </span>
                </div>
              </div>
              <div
                class="row"
                *ngIf="this.atribForm['data']['type'] === 'idate'"
              >
                <div class="col">
                  <label
                    for="futureDateLimit"
                    class="col col-form-label col-form-label-sm me-2"
                  >
                    {{
                      "ATTRIBUTES.MODAL.FIELDS.FUTURE_DATE_LIMIT" | translate
                    }}
                  </label>
                  <span
                    ncsTooltip
                    [matTooltip]="
                      'ATTRIBUTES.MODAL.TOOLTIPS.FUTURE_DATE_LIMIT' | translate
                    "
                  >
                    <i class="bi bi-info-circle text-secondary"></i>
                  </span>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <input
                      matInput
                      [(ngModel)]="this.atribForm['data']['futureDateLimit']"
                      id="futureDateLimit"
                      name="futureDateLimit"
                      type="number"
                      [value]="0"
                      [min]="1"
                      [placeholder]="
                        'ATTRIBUTES.MODAL.FIELDS.FUTURE_DATE_LIMIT' | translate
                      "
                      aria-label="Future Date Limit"
                    />
                  </mat-form-field>
                </div>
                <div class="col">
                  <label
                    for="pastDateLimit"
                    class="col col-form-label col-form-label-sm me-2"
                  >
                    {{ "ATTRIBUTES.MODAL.FIELDS.PAST_DATE_LIMIT" | translate }}
                  </label>
                  <span
                    ncsTooltip
                    [matTooltip]="
                      'ATTRIBUTES.MODAL.TOOLTIPS.PAST_DATE_LIMIT' | translate
                    "
                  >
                    <i class="bi bi-info-circle text-secondary"></i>
                  </span>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <input
                      matInput
                      [(ngModel)]="this.atribForm['data']['pastDateLimit']"
                      id="pastDateLimit"
                      name="pastDateLimit"
                      type="number"
                      [value]="0"
                      [min]="1"
                      [placeholder]="
                        'ATTRIBUTES.MODAL.FIELDS.PAST_DATE_LIMIT' | translate
                      "
                      aria-label="pastDateLimit"
                    />
                  </mat-form-field>
                </div>
              </div>

              <div class="row my-2">
                <div class="col-12 mb-3">
                  <label for="description" class="form-label me-2">
                    {{ "ATTRIBUTES.MODAL.FIELDS.DESCRIPTION" | translate }}
                  </label>
                  <span
                    [matTooltip]="
                      'ATTRIBUTES.MODAL.TOOLTIPS.DESCRIPTION' | translate
                    "
                    ncsTooltip
                  >
                    <i class="bi bi-info-circle text-secondary"></i>
                  </span>
                  <label for="description" class="form-label ms-2">
                    {{ "ALLREMAININGS.DESCRIPTION_SHOW" | translate }}
                  </label>
                  <mat-checkbox
                    [(ngModel)]="atribForm['data']['showDescription']"
                    id="showDescription"
                    name="showDescription"
                    color="primary"
                    class="me-2 mt-1"
                    (ngModelChange)="
                      this.toggleVal(
                        atribForm['data']['showDescription'],
                        atribForm['data'],
                        'showDescription'
                      )
                    "
                  >
                  </mat-checkbox>
                  <div class="textarea-container">
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <textarea
                        matInput
                        [(ngModel)]="atribForm['data']['description']"
                        id="description"
                        name="description"
                        [placeholder]="
                          'ATTRIBUTES.MODAL.FIELDS.DESCRIPTION_PLACEHOLDER'
                            | translate
                        "
                        rows="3"
                      >
                      </textarea>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-12">
                  <label for="regex" class="form-label me-2">
                    {{ "ATTRIBUTES.MODAL.FIELDS.REGEX" | translate }}
                  </label>
                  <span
                    [matTooltip]="'ATTRIBUTES.MODAL.TOOLTIPS.REGEX' | translate"
                    ncsTooltip
                  >
                    <i class="bi bi-info-circle text-secondary"></i>
                  </span>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <input
                      matInput
                      [(ngModel)]="this.atribForm['data']['regex']"
                      type="text"
                      class="w-100"
                      id="regex"
                      name="regex"
                      [placeholder]="
                        'ATTRIBUTES.MODAL.FIELDS.REGEX_PLACEHOLDER' | translate
                      "
                    />
                  </mat-form-field>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col mt-2">
                  <mat-checkbox
                    [(ngModel)]="atribForm['data']['allowChangeAfterInitial']"
                    id="allowChangeAfterInitial"
                    name="allowChangeAfterInitial"
                    color="primary"
                    (ngModelChange)="
                      toggleVal(
                        atribForm['data']['allowChangeAfterInitial'],
                        atribForm['data'],
                        'allowChangeAfterInitial'
                      )
                    "
                  >
                  </mat-checkbox>
                  <label
                    class="form-check-label me-2"
                    for="allowChangeAfterInitial"
                  >
                    {{
                      "ATTRIBUTES.MODAL.OPTIONS.NO_CHANGE_AFTER_INIT"
                        | translate
                    }}
                  </label>
                  <span
                    [matTooltip]="
                      'ATTRIBUTES.MODAL.TOOLTIPS.NO_CHANGE_AFTER_INIT'
                        | translate
                    "
                    ncsTooltip
                  >
                    <i class="bi bi-info-circle text-secondary"></i>
                  </span>
                </div>
              </div>

              <div
                class="row"
                *ngIf="this.atribForm['data']['type'] === 'time'"
              >
                <div class="col-auto">
                  <div class="d-flex align-items-center flex-wrap mt-2">
                    <label class="form-label me-3 mb-2 mb-md-0"
                      >{{
                        "ATTRIBUTES.MODAL.FIELDS.TIME_FORMAT" | translate
                      }}:</label
                    >

                    <mat-radio-group
                      name="timeFormat"
                      [(ngModel)]="timeFormat"
                      class="d-flex flex-wrap align-items-center"
                    >
                      <mat-radio-button
                        id="format24"
                        value="24"
                        color="primary"
                        class="me-3 mb-1"
                      >
                        {{
                          "ATTRIBUTES.MODAL.OPTIONS.TIME_FORMAT_24" | translate
                        }}
                      </mat-radio-button>
                      <mat-radio-button
                        id="format12"
                        value="12"
                        color="primary"
                        class="me-3 mb-1"
                      >
                        {{
                          "ATTRIBUTES.MODAL.OPTIONS.TIME_FORMAT_12" | translate
                        }}
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
              <div
                class="row"
                *ngIf="this.atribForm['data']['type'] === 'itime'"
              >
                <div class="col-auto">
                  <div class="d-flex align-items-center flex-wrap mb-3">
                    <label class="form-label me-3 mb-2 mb-md-0"
                      >{{
                        "ATTRIBUTES.MODAL.FIELDS.TIME_FORMAT" | translate
                      }}:</label
                    >

                    <mat-radio-group
                      name="itimeFormat"
                      [(ngModel)]="itimeFormat"
                      class="d-flex flex-wrap align-items-center"
                    >
                      <mat-radio-button
                        id="iformat24"
                        value="24"
                        color="primary"
                        class="me-3 mb-1"
                      >
                        {{
                          "ATTRIBUTES.MODAL.OPTIONS.TIME_FORMAT_24" | translate
                        }}
                      </mat-radio-button>
                      <mat-radio-button
                        id="iformat12"
                        value="12"
                        color="primary"
                        class="me-3 mb-1"
                      >
                        {{
                          "ATTRIBUTES.MODAL.OPTIONS.TIME_FORMAT_12" | translate
                        }}
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
              <div
                class="row mt-2"
                *ngIf="atribForm?.data?.type === 'textarea'"
              >
                <div class="col">
                  <div class="d-flex align-items-center flex-wrap">
                    <mat-checkbox
                      [(ngModel)]="atribForm['data']['enableEditor']"
                      id="enableEditor"
                      name="enableEditor"
                      color="primary"
                      class="me-2"
                      (ngModelChange)="
                        toggleVal(
                          atribForm['data']['enableEditor'],
                          atribForm['data'],
                          'enableEditor'
                        )
                      "
                    >
                    </mat-checkbox>
                    <label class="form-check-label me-2" for="enableEditor">
                      {{ "ATTRIBUTES.MODAL.OPTIONS.HTML_EDITOR" | translate }}
                    </label>
                    <span
                      ncsTooltip
                      [matTooltip]="
                        'ATTRIBUTES.MODAL.TOOLTIPS.HTML_EDITOR' | translate
                      "
                    >
                      <i class="bi bi-info-circle text-secondary"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row mt-2" *ngIf="atribForm?.data?.type === 'list'">
                <div class="col">
                  <mat-checkbox
                    [(ngModel)]="atribForm['data']['multipleSelect']"
                    id="multipleSelect"
                    name="multipleSelect"
                    color="primary"
                    class="me-2"
                    (ngModelChange)="
                      toggleVal(
                        atribForm['data']['multipleSelect'],
                        atribForm['data'],
                        'multipleSelect'
                      )
                    "
                  >
                  </mat-checkbox>
                  <label class="form-check-label me-2" for="multipleSelect">
                    {{ "ATTRIBUTES.MODAL.OPTIONS.MULTIPLE_SELECT" | translate }}
                  </label>
                  <span
                    ncsTooltip
                    [matTooltip]="
                      'ATTRIBUTES.MODAL.TOOLTIPS.MULTIPLE_SELECT' | translate
                    "
                  >
                    <i class="bi bi-info-circle text-secondary"></i>
                  </span>
                </div>
              </div>
              <!-- <div class="form-check"
                                *ngIf="atribForm['data']['type'] === 'text' || atribForm['data']['type'] === 'number'">
                                <input [(ngModel)]="atribForm['data']['sequence']" class="form-check-input"
                                    type="checkbox" id="sequence" name="sequence"
                                    [disabled]="atribForm['data']['sequenceId']"
                                    (change)="this.toggleVal(atribForm['data']['sequence'], atribForm['data'], 'sequence')">
                                <label class="form-check-label" for="sequence">
                                    {{ 'ATTRIBUTES.MODAL.OPTIONS.ENABLE_SEQUENCE' | translate }}
                                </label>
                            </div> -->
              <div
                *ngIf="
                  atribForm['data']['type'] === 'text' ||
                  atribForm['data']['type'] === 'number'
                "
              >
                <mat-checkbox
                  [(ngModel)]="atribForm['data']['sequence']"
                  id="sequence"
                  name="sequence"
                  color="primary"
                  [disabled]="atribForm['data']['sequenceId']"
                  (ngModelChange)="
                    this.toggleVal(
                      atribForm['data']['sequence'],
                      atribForm['data'],
                      'sequence'
                    )
                  "
                >
                </mat-checkbox>
                <label class="form-check-label" for="sequence">
                  {{ "ATTRIBUTES.MODAL.OPTIONS.ENABLE_SEQUENCE" | translate }}
                </label>
              </div>

              <!-- <div *ngIf="atribForm['data']['sequence']" class="row">
                                <div class="col-md-4 mb-3" *ngIf="atribForm['data']['type'] === 'text'">
                                    <label for="prefix" class="form-label">
                                        {{ 'ATTRIBUTES.MODAL.FIELDS.PREFIX' | translate }}
                                    </label>
                                    <input id="prefix" [(ngModel)]="sequence['data']['prefix']"
                                        [readOnly]="atribForm['data']['sequenceId']" name="prefix"
                                        [placeholder]="'ATTRIBUTES.MODAL.FIELDS.PREFIX_PLACEHOLDER' | translate"
                                        type="text" class="form-control form-control-sm">
                                </div>

                                <div class="col-md-4 mb-3">
                                    <label for="startIndex" class="form-label">
                                        {{ 'ATTRIBUTES.MODAL.FIELDS.START_INDEX' | translate }} fff
                                    </label>
                                    <input id="startIndex" (input)="preventNegative($event)"
                                        [(ngModel)]="sequence['data']['startIndex']"
                                        [readOnly]="atribForm['data']['sequenceId']" name="startIndex"
                                        [placeholder]="'ATTRIBUTES.MODAL.FIELDS.START_INDEX_PLACEHOLDER' | translate"
                                        type="text" class="form-control form-control-sm">
                                </div>

                                <div class="col-md-4 mb-3" *ngIf="atribForm['data']['type'] === 'text'">
                                    <label for="suffix" class="form-label">
                                        {{ 'ATTRIBUTES.MODAL.FIELDS.SUFFIX' | translate }}
                                    </label>
                                    <input id="suffix" [(ngModel)]="sequence['data']['suffix']"
                                        [readOnly]="atribForm['data']['sequenceId']" name="suffix"
                                        [placeholder]="'ATTRIBUTES.MODAL.FIELDS.SUFFIX_PLACEHOLDER' | translate"
                                        type="text" class="form-control form-control-sm">
                                </div>
                            </div> -->
              <div *ngIf="atribForm['data']['sequence']" class="row mt-2">
                <!-- Prefix Field (only for text type) -->
                <div
                  class="col-md-4 mb-3"
                  *ngIf="atribForm['data']['type'] === 'text'"
                >
                  <mat-label>{{
                    "ATTRIBUTES.MODAL.FIELDS.PREFIX" | translate
                  }}</mat-label>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <input
                      matInput
                      id="prefix"
                      [(ngModel)]="sequence['data']['prefix']"
                      [readonly]="atribForm['data']['sequenceId']"
                      name="prefix"
                      [placeholder]="
                        'ATTRIBUTES.MODAL.FIELDS.PREFIX_PLACEHOLDER' | translate
                      "
                      type="text"
                    />
                  </mat-form-field>
                </div>

                <!-- Start Index Field -->
                <div class="col-md-4 col-12 mb-3">
                  <mat-label>{{
                    "ATTRIBUTES.MODAL.FIELDS.START_INDEX" | translate
                  }}</mat-label>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <input
                      matInput
                      id="startIndex"
                      (input)="preventNegative($event)"
                      [(ngModel)]="sequence['data']['startIndex']"
                      [readonly]="atribForm['data']['sequenceId']"
                      name="startIndex"
                      type="number"
                    />
                  </mat-form-field>
                </div>

                <!-- Suffix Field (only for text type) -->
                <div
                  class="col-md-4 mb-3"
                  *ngIf="atribForm['data']['type'] === 'text'"
                >
                  <mat-label>{{
                    "ATTRIBUTES.MODAL.FIELDS.SUFFIX" | translate
                  }}</mat-label>
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100"
                  >
                    <input
                      matInput
                      id="suffix"
                      [(ngModel)]="sequence['data']['suffix']"
                      [readonly]="atribForm['data']['sequenceId']"
                      name="suffix"
                      [placeholder]="
                        'ATTRIBUTES.MODAL.FIELDS.SUFFIX_PLACEHOLDER' | translate
                      "
                      type="text"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button
          mat-stroked-button
          color="primary"
          type="button"
          class="me-2"
          (click)="saveAttribute()"
          [disabled]="!uiForm.valid"
        >
          <mat-icon>save</mat-icon> {{ "COMMON.SAVE" | translate }}
        </button>

        <button
          mat-stroked-button
          type="button"
          color="warn"
          class="ms-2"
          data-bs-dismiss="modal"
          (click)="
            clear();
            atribForm['data']['values'] = [];
            tempAttributeValue = '';
            tempKey = '';
            tempMapValue = ''
          "
        >
          <mat-icon>close</mat-icon> {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Add Rule Modal -->
<div
  class="modal fade"
  id="addRule"
  tabindex="-1"
  aria-labelledby="addRuleLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="addRuleLabel">
          {{ "RULES.ADD_RULE" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [title]="'COMMON.CLOSE' | translate"
        ></button>
      </div>

      <div class="modal-body">
        <div class="row">
          <p *ngIf="ruleData['error'] == false && ruleData['message']">
            <app-ncs-alert
              [message]="ruleData['message']"
              type="success"
            ></app-ncs-alert>
          </p>
          <p *ngIf="ruleData['error'] == true && ruleData['message']">
            <app-ncs-alert
              [message]="ruleData['message']"
              type="danger"
            ></app-ncs-alert>
          </p>
          <!-- Event Selection -->
          <div class="row mb-3 compact-inputs">
            <label class="col-md-3 col-form-label text-start"
              >{{ "RULES.SELECT_EVENT" | translate }}:</label
            >
            <div class="col-md-9">
              <mat-form-field
                appearance="outline"
                class="w-100"
                subscriptSizing="dynamic"
              >
                <mat-label>{{ "COMMON.SELECT" | translate }}</mat-label>
                <mat-select
                  [ngModel]="ruleData.data['event']"
                  (ngModelChange)="ruleData.data['event'] = $event"
                  placeholder="{{ 'COMMON.SELECT' | translate }}"
                >
                  <mat-option value="undefined">{{
                    "COMMON.SELECT" | translate
                  }}</mat-option>
                  <mat-option value="beforeSubmit">{{
                    "RULES.EVENTS.BEFORE_SUBMIT" | translate
                  }}</mat-option>
                  <mat-option value="afterSubmit">{{
                    "RULES.EVENTS.AFTER_SUBMIT" | translate
                  }}</mat-option>
                  <mat-option value="beforeInsert">{{
                    "RULES.EVENTS.BEFORE_INSERT" | translate
                  }}</mat-option>
                  <mat-option value="afterInsert">{{
                    "RULES.EVENTS.AFTER_INSERT" | translate
                  }}</mat-option>
                  <mat-option value="beforeUpdate">{{
                    "RULES.EVENTS.BEFORE_UPDATE" | translate
                  }}</mat-option>
                  <mat-option value="afterUpdate">{{
                    "RULES.EVENTS.AFTER_UPDATE" | translate
                  }}</mat-option>
                  <mat-option value="beforeDelete">{{
                    "RULES.EVENTS.BEFORE_DELETE" | translate
                  }}</mat-option>
                  <mat-option value="afterDelete">{{
                    "RULES.EVENTS.AFTER_DELETE" | translate
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <!-- Rule Text Area -->
          <div class="row mb-3">
            <label class="col-md-3 col-form-label text-start"
              >{{ "RULES.RULE_LOGIC" | translate }}:</label
            >
            <div class="col-md-9 textarea-container">
              <mat-form-field appearance="outline" class="w-100">
                <textarea
                  matInput
                  [(ngModel)]="ruleData.data['rule']"
                  rows="4"
                  placeholder="{{ 'RULES.RULE_PLACEHOLDER' | translate }}"
                >
                </textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer Buttons -->
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="primary"
          class="ms-2"
          (click)="addRuleWithText()"
          [disabled]="
            !ruleData?.data['event'] ||
            ruleData?.data['event'] === 'undefined' ||
            !ruleData?.data['rule']
          "
        >
          <mat-icon>save</mat-icon>
          {{ "COMMON.SAVE" | translate }}
        </button>

        <button
          mat-stroked-button
          type="button"
          color="warn"
          data-bs-dismiss="modal"
          [matTooltip]="'COMMON.CLOSE' | translate"
        >
          <mat-icon>close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Bootstrap Modal for Errors -->
<div
  class="modal fade"
  id="errorModal"
  tabindex="-1"
  aria-labelledby="errorModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="errorModalLabel">
          Upload Errors (with Row Numbers)
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="table-container">
          <div
            class="table-responsive"
            style="max-height: 450px; overflow-y: auto"
          >
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>{{ "COMMON.ROW_NUMBER" | translate }}</th>
                  <th>{{ "COMMON.ER_MSG" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let error of errorList">
                  <td>{{ error.rowNumber }}</td>
                  <td>{{ error.message }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
